import { createSlice } from '@reduxjs/toolkit';

type Model = {
  id: string;
  name: string;
  providedBy: string;
  modelCode: string;
  ctFactor: string;
  ptFactor: string;
  accuracy: number;
  speed: number;
  price: number;
  imageAnalysis: string;
  region: string;
  tokenLimit: string;
  temperature: string;
};

type ModelReducer = {
  selectedModel?: Model;
  models: Model[];
  searchFilter?: string;
};

const initialState: ModelReducer = {
  models: [],
  selectedModel: undefined
};

const ModelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    applySearchFilter: (state, action) => {
      state.searchFilter = action.payload;
    },
    selectModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    addModel: (state, action) => {
      state.models.unshift(action.payload);
    },
    updateModel: (state, action) => {
      const index = state.models.findIndex(
        (model) => model.id === action.payload.id
      );
      if (index !== -1) {
        state.models[index] = action.payload;
      }
    }
  }
});

export default ModelSlice;
export const reducer = ModelSlice.reducer;
export const { addModel, updateModel, selectModel, applySearchFilter } = ModelSlice.actions;
